<template>
    <div class="vc-panel mpanel">
        <div v-if="saleConfig!=null">
            <h1>升级VIP会员</h1>
            <div class="grid" v-for="block in saleConfig.series" :key="block">
                <div @click="openBuyDialog(item)" class="grid-item focus-s" v-for="item in block.items" :key="item">
                    <div>
                        <h2>{{item.name}}</h2>
                        <p>{{item.desc}}</p>
                    </div>
                    <div>
                        <span>{{item.price}}</span>
                        <span>元</span>
                    </div>
                </div>
            </div>
        </div>
        <!--支付对话框-->
        <MemberPaymentDialog :showDialog="payDialog.show" :saleItem="payDialog.item" @closeDialog="payDialog.callBack"></MemberPaymentDialog>
    </div>
</template>

<script>
import httpClient from '@/commom/http/httpClient';
import MemberPaymentDialog from './dialog/MemberPaymentDialog.vue';
export default {
    name: 'BuyMemberPage',
    components:{
        MemberPaymentDialog
    },
    data() {
        return {
            saleConfig: null,
            payDialog:{
                show:false,
                item:null,
                callBack:null
            }
        }
    },
    mounted: function () {
        this.loadData()
    },
    methods: {
        ///加载数据
        loadData: function () {
            var req = {}
            var that = this
            httpClient.invoke("SaleAPI.GetSaleConfig", req, function (res) {
                console.log("输出结果", res)
                if (res.error) {
                    that.$message.error(res.error)
                    return
                }
                that.saleConfig = res
            })
        },
        ///打开购买对话框
        openBuyDialog:function(item){
            this.payDialog.show = true
            this.payDialog.item = item
            var that = this 
            this.payDialog.callBack = function(done){
                that.payDialog.show = false
                if(done){
                    that.$message.success("支付成功")
                    ///通知刷新会员信息
                }   
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mpanel {
    padding: 20px;
}

.grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 20px;
    margin-top: 30px;
}

.grid-item {
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 10px;
}
</style>
